import { z } from "zod"

import { FieldGroupEnum } from "@/graphql/codegen/graphql"

export const CompanyFileSchema = z.object({
  companyId: z.string(),
  fileType: z
    .enum([FieldGroupEnum.Brochure, FieldGroupEnum.TechnicalData, FieldGroupEnum.Miscellaneous])
    .nullable()
    .refine((fileType) => fileType !== null, {
      message: "Please select a file type",
    }),
  file: z
    .instanceof(File)
    .nullable()
    .refine((file) => file !== null, {
      message: "Please upload a file",
    }),
})

export type CompanyFileFormValues = z.infer<typeof CompanyFileSchema>
